import { TeContainerSlim, TeIcon, TeTag, TeText } from '@topcon/tuicl-react';

import OrgCard from '../OrgCard';

interface Props {
  /** e.g. "Incoming organization from:" — already translated. */
  label: string;
  name: string;
  sourceSystem?: string;
  /** Already formatted single-line address; omitted when empty. */
  address?: string;
}

/**
 * The incoming Migration Candidate at the top of a Review modal: the
 * "from &lt;source system&gt;" label followed by a read-only organization card.
 * Shared by the identity-scope and dealer-scope Review modals, and by the
 * Connect wizard's first step (to show which incoming suggestion a Connect
 * corresponds to).
 */
function IncomingOrganizationCard({ label, name, sourceSystem, address }: Props) {
  return (
    <>
      <TeContainerSlim gap="xs" alignItems="center">
        <TeContainerSlim gap="xs2" alignItems="center">
          <TeText size={14} weight={500}>
            {label}
          </TeText>
          {sourceSystem && (
            <TeTag
              size="s"
              text={sourceSystem}
              backgroundColor="background.tertiary"
              textColor="text.primary"
              borderColor="border.primary"
            />
          )}
        </TeContainerSlim>
        <TeIcon name="info" size="m" color="icon.secondary" />
      </TeContainerSlim>

      <OrgCard name={name} address={address || undefined} baseBackground="primary" addressFill />
    </>
  );
}

export default IncomingOrganizationCard;
